document.addEventListener('DOMContentLoaded', function () {
	const config = window.thriveAuthUi || {};
	const loginUrl = config.loginUrl || '/';
	const backToLoginLabel = config.backToLoginLabel || 'Back to login';

	const login = document.getElementById('login');
	const lostPasswordForm = document.getElementById('lostpasswordform');
	const resetForm = document.getElementById('resetpassform') || document.getElementById('lostpasswordform');

	if (document.body.classList.contains('login-action-lostpassword')) {
		const input = document.getElementById('user_login');
		const actions = lostPasswordForm ? lostPasswordForm.querySelector('.thrive-auth-actions') : null;
		const submit = lostPasswordForm ? lostPasswordForm.querySelector('p.submit') : null;

		if (input) {
			input.setAttribute('placeholder', 'Username or Email Address');
		}

		if (actions && submit) {
			actions.appendChild(submit);
		}
	}

	if (
		document.body.classList.contains('login-action-rp') ||
		document.body.classList.contains('login-action-resetpass')
	) {
		const pass1 = document.getElementById('pass1');
		const pass2 = document.getElementById('pass2');
		const actions = resetForm ? resetForm.querySelector('.thrive-auth-actions') : null;
		const submit = resetForm ? resetForm.querySelector('p.submit, .reset-pass-submit') : null;

		if (pass1) {
			pass1.setAttribute('placeholder', 'New password');
		}

		if (pass2) {
			pass2.setAttribute('placeholder', 'Repeat new password');
		}

		if (actions && submit) {
			actions.appendChild(submit);
		}
	}

	if (document.body.classList.contains('thrive-login-confirm')) {
		if (!login || login.querySelector('.thrive-login-confirm-actions')) {
			return;
		}

		const actions = document.createElement('div');
		actions.className = 'thrive-login-confirm-actions';

		const link = document.createElement('a');
		link.href = loginUrl;
		link.textContent = backToLoginLabel;

		actions.appendChild(link);
		login.appendChild(actions);
	}
});
